import React from "react";
import {observer} from "mobx-react";
import {GamesOpenSessionDateContainerBox} from "./boxes/session-date/games-open-session-date-container.box";
import {GamesOpenSessionCalendarIconBox} from "./boxes/session-date/games-open-session-calendar-icon.box";
import {IGameOpenSessionViewModel} from "../../../../services/games-open-sessions/games-open-session.service.interface";
import {useServices} from "../../../../react-hooks/use-services.hook";

export const GamesOpenSessionRecordDateComponent: React.FC<{openSession: IGameOpenSessionViewModel}> = observer((props) => {
    const services = useServices();
    if(!props.openSession.gameStartDate) {
        return null;
    }

    return (
        <GamesOpenSessionDateContainerBox>
            <GamesOpenSessionCalendarIconBox/>
            <div>
                {services.regulation.current.timeFormatter.formatHistoryRecordDate(props.openSession.gameStartDate)}
            </div>

        </GamesOpenSessionDateContainerBox>
    );
})